export function hasValidationError(errorMessage: string | undefined): errorMessage is string {
    return errorMessage != null;
}
